// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// importing styles
import "./src/styles/main.scss"
